import {Component, EventEmitter, Input, Output} from '@angular/core';
import {SentEmailModel} from '../models/sent-email.model';

@Component({
  selector: 'app-sent-emails-dialog',
  templateUrl: './sent-emails-dialog.component.html',
  standalone: false
})
export class SentEmailsDialogComponent {
  @Input() visible = false;
  @Output() visibleChange: EventEmitter<boolean> = new EventEmitter<boolean>();

  @Input() emails: SentEmailModel[] = [];

  onVisibleChange(nextVisible: boolean): void {
    this.visible = nextVisible;
    this.visibleChange.emit(nextVisible);
  }
}

